import { combineTokens } from '@utils/css';

const tokens = combineTokens("--video-media", {
  aspect: "16 / 9",
  originalHeight: "10000px",
  originalWidth: "10000px"
});
const player = "_35spfhm77i";
const printWrapper = "_35sp1g5v4se";
const printThumbnail = "_35spklnhi3";
const printPlayIcon = "_35spdqsgst";

export { player, printPlayIcon, printThumbnail, printWrapper, tokens };
import "./video.style.linaria.module.css";
//# sourceMappingURL=video.style.js.map
